<div class="chip-popover"
     [style.--chip-popover-accent-ink]="chipInk || null"
     [style.--chip-popover-card-ink]="chipInkOnCard || null">
  <div class="accent-bar"></div>

  <div class="header">
    <div class="avatar" [style.--avatar-accent]="accentColor">
      <span class="avatar-icon" [ngStyle]="iconMaskStyles" aria-hidden="true"></span>
    </div>
    <div class="header-text">
      <div class="title">{{ title }}</div>
    </div>
    <button class="close-btn" type="button" (click)="close()" [attr.aria-label]="'CLOSE' | translate">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>

  <div class="body">
    <div class="row" *ngIf="timeRange">
      <ion-icon class="row-icon" name="time-outline"></ion-icon>
      <div class="row-text">
        <div class="row-label">{{ dateLabel }}</div>
        <div class="row-value">
          {{ timeRange }}<span class="row-meta" *ngIf="durationLabel"> · {{ durationLabel }}</span>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showLocationAndType">
      <div class="row">
        <ion-icon class="row-icon" name="location-outline"></ion-icon>
        <div class="row-text">
          <div class="row-label">{{ 'ACTIVITY_DETAILS_LOCATION' | translate }}</div>
          <div class="row-value">{{ location }}</div>
        </div>
      </div>
      <div class="row">
        <ion-icon class="row-icon" name="pricetag-outline"></ion-icon>
        <div class="row-text">
          <div class="row-label">{{ 'FORMAT' | translate }}</div>
          <span class="type-pill" [style.background]="accentColor">
            <span class="type-pill-dot"></span>{{ typeLabel }}
          </span>
        </div>
      </div>
    </ng-container>
    <div class="row" *ngIf="isAppointment">
      <ion-icon class="row-icon" name="person-outline"></ion-icon>
      <div class="row-text">
        <div class="row-label">{{ customerLabel }}</div>
        <div class="row-value">{{ customer }}</div>
      </div>
    </div>
    <div class="row" *ngIf="isTimeOff && reason">
      <ion-icon class="row-icon" name="document-text-outline"></ion-icon>
      <div class="row-text">
        <div class="row-label">{{ reasonLabel }}</div>
        <div class="row-value">{{ reason }}</div>
      </div>
    </div>
  </div>

  <div class="actions">
    <ion-button class="open-btn" size="small" fill="solid" (click)="open()">{{ 'VIEW_DETAILS' | translate }}</ion-button>
  </div>
</div>
